import React, { useEffect, useState } from "react";
import drop from "../../assets/images/icon_home/drop.svg";
import userweb from "../../assets/images/icon_home/userweb.svg";
import messageweb from "../../assets/images/icon_home/messageweb.svg";
import homeweb from "../../assets/images/icon_home/homeweb.svg";
import chart from "../../assets/images/icon_home/chart.svg";
import message from "../../assets/images/icon_home/message.svg";
import menuonactive from "../../assets/images/icon_home/menunonactive.svg";
import stats from "../../assets/images/icon_home/statsweb.svg";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setLoading } from "../../core/feature/config/configSlice";
import { iteratorSymbol } from "immer/dist/internal";
import { useAppSelector } from "../../core/feature/hooks";
import CustomApp from "../../core/models/customApp";
import { t } from "i18next";
import { useTranslation } from "react-i18next";
import { getNotifData } from "../../core/service/api_notification";
import { isDarkColor } from "../../config/DarkColorChecker";

export default function Navbar(props: any) {
  const [isMenuActive, setIsMenuActive] = useState(props.item);
  const [data, setData] = useState();
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);
  const { t } = useTranslation();
  const [pageI, setPageI] = useState(0);
  const [sizeI, setSizeI] = useState(10);
  const [totalI, setTotalI] = useState(0);
  const [menu, setMenu] = useState([
    {
      title: "Home",
      subtitle: t("NAVBAR.home"),
      iconActive: homeweb,
      iconNonActive: menuonactive,
      path: "/home",
    },
    {
      title: "Informasi",
      subtitle: t("NAVBAR.info"),
      iconActive: chart,
      iconNonActive: stats,
      path: "/info",
    },
    {
      title: "Pesan",
      subtitle: t("NAVBAR.inbox"),
      iconActive: message,
      iconNonActive: messageweb,
      path: "/message",
    },
    {
      title: "Profile",
      subtitle: t("NAVBAR.profile"),
      path: "/profile",
      iconActive: userweb,
      iconNonActive: userweb,
    },
  ]);

  return (
    <div className="mx-auto container w-full flex flex-col justify-start items-center relative z-40">
      <div className="relative flex items-center justify-between lg:justify-center lg:space-x-16">
        <ul className="flex items-center  space-x-8 lg:flex mt-8">
          {menu.map((e, i) => {
            if (e.title == isMenuActive) {
              return (
                <Link to={e.path} key={i} className="no-underline">
                  {e.title === "Pesan" ? (
                    <li
                      className="grow flex flex-row justify-center h-30 gap-2 px-3 py-2.5 m-2 rounded-full"
                      style={{
                        backgroundColor: props.colorsecond,
                      }}
                    >
                      <div className="flex flex-row items-center gap-2 w-fit">
                        <img src={e.iconActive} className={`h-6 lg:h-6 ${isDarkColor(props.colorsecond)? '' : 'invert'}`} />
                        <span className={`${isDarkColor(props.colorsecond)?'text-white':'text-black'}`}>{e.subtitle}</span>
                        {/* <div className="rounded-full  text-xs bg-red h-auto w-auto px-2 text-white">
                          {props.total}
                        </div> */}
                      </div>
                    </li>
                  ) : (
                    <li
                      className="grow flex flex-row justify-center h-30 gap-2 px-3 py-2.5 m-2 rounded-full"
                      style={{
                        backgroundColor: props.colorsecond,
                      }}
                    >
                      <div className="flex flex-row items-center gap-2 w-fit">
                        <img src={e.iconActive} className={`h-6 lg:h-6 ${isDarkColor(props.colorsecond)? '' : 'invert'}`} />
                        <span className={`${isDarkColor(props.colorsecond)?'text-white':'text-black'}`}>{e.subtitle}</span>
                      </div>
                    </li>
                  )}
                </Link>
              );
            } else {
              return (
                <Link key={i} to={e.path} className="no-underline relative">
                  {e.title === "Pesan" ? (
                    <li className="flex-0 px-3">
                      <img
                        src={e.iconNonActive}
                        alt=""
                        className={`h-6 lg:h-6 ${isDarkColor(props.color)?'':'invert'}`}
                      />
                      {/* <div className="rounded-full  text-xs bg-red h-2 w-2 top-0 right-2 absolute">
                        {props.total}
                      </div> */}
                    </li>
                  ) : (
                    <li className="flex-0 px-3">
                      <img
                        src={e.iconNonActive}
                        alt=""
                        className={`h-6 lg:h-6 ${isDarkColor(props.color)?'':'invert'}`}
                      />
                    </li>
                  )}
                </Link>
              );
            }
          })}
        </ul>
      </div>
    </div>
  );
}
